export default function InterestingComponentIndex({text, image}) {
  return (
    <div className="interesting-item">
        <div>
            <img src={image} alt={text}/>
        </div>
        <p>{text}</p>
    </div>
  );
}